import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';

export const POOL_ID = "us-west-2_Vnfo7r1kd";
export const POOL_ARN = "arn:aws:cognito-idp:us-east-2:850340806911:userpool/us-east-2_oHn8RVDeh";
export const CLIENT_ID = "19il0dmid0mgfa4pct4kov0i1i";
export const TENANT_ID = "90000100";

export const AUTH = {
    editAuthorization: {
        path: "/root",
        resourceName: "editAuthorization"
    },
    licenseManagement: {
        path: "/root/menusifu",
        resourceName: "license"
    },
    employeeManagement: {
        path: "/root/menusifu",
        resourceName: "emplyeeManagement"
    },
    report: {
        path: "/root/menusifu/report",
        resourceName: "edit"
    },
}